export enum ExtraAssetOption {
    OWN_PROPERTY,
    OWN_MONEY,
    SUMMARY
}

export enum OwnPropertyQuestion {
    OWN_PROPERTY_BUTTON,
    SELLING_PRICE_INPUT,
    MORTGAGE_AMOUNT_INPUT,
    SUMMARY
}

export enum OwnMoneyQuestion {
    OWN_MONEY_BUTTON,
    OWN_MONEY_AMOUNT_INPUT,
    SUMMARY
}
